// extracted by mini-css-extract-plugin
export default {"card":"YS","autoAlign":"ZS","cardrow":"aT","cardcentered":"bT","details":"cT","imgwrapper":"eT","img":"fT","category":"gT","name":"hT","copy":"iT","detailsbtn":"jT","remove":"kT","price":"lT","netPrice":"mT","regularPrice":"nT","label":"oT"};
    if(module.hot) {
      // 1738836197791
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  